<template>
    <div>
        <v-dialog
            v-model="addBillingCodeDialog"
            persistent
            width="500"
        >
            <template v-slot:activator="{ attrs }">
                <v-btn
                    depressed
                    outlined
                    v-bind="attrs"
                    @click="openDialog"
                >
                    <v-icon
                        left
                        class="action-icon"
                    >
                        mdi-plus
                    </v-icon>
                    Add Billing Code
                </v-btn>            
            </template>
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    <span>Add Billing Code</span>                
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="formValid"
                    >
                        <v-row class="mt-5">
                            <v-col
                                cols="12"
                                sm="12"
                                class="py-0"
                            >  
                                <v-select
                                    v-if="addBillingCodeDialog"
                                    v-model="code"                                
                                    label="Billing Code"
                                    :items="companyBillingCodes.map((item) => item.code)"                                
                                    outlined
                                    dense
                                    class="upper-case"
                                    :rules="billingCodeRules"
                                    @change="onCodeChange"                                    
                                />                           
                            </v-col>
                            <v-col
                                v-if="addBillingCodeDialog"
                                cols="12"
                                md="12"
                                class="py-0"
                            >
                                <v-text-field
                                    v-model="quantity"
                                    label="Quantity"
                                    outlined
                                    dense
                                    type="number"
                                    required
                                    :rules="quantityRules"
                                />
                            </v-col>
                            <v-col  
                                v-if="showBillingAmount"
                                cols="12"
                                md="12"
                                class="py-0"
                            >
                                <v-text-field
                                    v-if="addBillingCodeDialog"
                                    v-model="amount"
                                    label="Amount"
                                    outlined
                                    dense
                                    class="upper-case"
                                    :rules="amountRules"                                    
                                /> 
                            </v-col>
                            <v-col
                                cols="12"
                                md="12"
                                class="py-0"
                            >
                                <v-select
                                    v-if="addBillingCodeDialog"
                                    v-model="minutes"
                                    :items="billingCodeTimeWorked"
                                    item-text="label"
                                    item-value="value"          
                                    label="Time Worked"                               
                                    outlined
                                    dense
                                    class="upper-case"
                                    :rules="minutesRules"
                                />
                            </v-col>                       
                        </v-row>                             
                    </v-form>                
                </v-card-text>
                <v-divider />
                <v-card-actions>               
                    <v-btn
                        style="text-transform: none !important;"
                        outlined
                        light
                        @click="closedDialog"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        color="primary"
                        :disabled="!addBillingCodeDialog || !code || !minutes"
                        @click="save"
                    >
                        <span>Add</span>                   
                    </v-btn>
                </v-card-actions>           
            </v-card>
        </v-dialog>        
        <v-card v-if="billingCodes.length > 0">
            <v-card-title class="text-h5 lighten-2">
                <span>Billing Codes</span>                
            </v-card-title>
            <v-divider />
            <v-data-table               
                :headers="computedHeaders"
                :items="billingCodes"
                :items-per-page="5"
                class="elevation-1"
                hide-default-footer
                dense          
            >
                <template v-slot:[`item.code`]="{ item }">
                    {{ item.code }}
                </template>
                <template v-slot:[`item.quantity`]="{ item }">
                    {{ item.quantity }} 
                </template>
                <template v-slot:[`item.amount`]="{ item }">                    
                    <span v-if="showBillingAmount">
                        {{ formatCurrency(item.amount) }}
                    </span>
                </template> 
                <template v-slot:[`item.minutes`]="{ item }">
                    {{ getBillingMinutesLabel(item.minutes) }}
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <v-icon
                        class="action-icon"
                        @click="deleteBillingCode(item)" 
                    >
                        delete
                    </v-icon>
                </template> 
            </v-data-table>            
        </v-card>   
    </div>
</template>
<script>
import CompanyBillingMixin from '@/mixins/CompanyBillingMixin';
import { formatCurrency } from '@/utils/formatCurrency.js';
export default {
    mixins: [
        CompanyBillingMixin,
    ],
    props: {
        billingCodes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            headers: [
                { text: 'Code', value: 'code' },
                { text: 'Quantity', value: 'quantity'},
                { text: 'Amount', value: 'amount' },
                { text: 'Time Worked', value: 'minutes' },                
                {
                    text: 'Delete',
                    align: 'center',
                    value: 'delete',
                    sortable: false,
                }
            ],   
            formValid: false,
            addBillingCodeDialog: false,
            editBillingCodeDialog: false,            
            code: '',
            quantity: '',
            amount: '',
            minutes: '',
        };  
    },
    computed:{
        computedHeaders() {
            let headers = this.headers;
            if (!this.showBillingAmount) {
                headers = headers.filter(item => item.value !== 'amount');
            }
            return headers;
        },},  
    methods: {
        openDialog(){
            this.addBillingCodeDialog = true;
            this.resetFormData();
        },
        closedDialog() {
            // this.resetFormData();
            this.addBillingCodeDialog = false;            
        },
        capitalized(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        resetFormData() {
            this.code = '';
            this.quantity = '';
            this.amount = '';
            this.minutes = '';
            this.formValid = false;           
        },
        async save() {
            this.billingCodes.push({
                code: this.code,
                quantity: this.quantity,
                minutes: this.minutes,
                amount: this.amount,
            });
            
            this.handleBillingCodes();        
            
            this.resetFormData();
            this.addBillingCodeDialog = false;
        },
        async getBillingAmount(code) {
            let billingCode = await this.companyBillingCodes.find(item => item.code === code);
            return billingCode.amount;
        },
        async deleteBillingCode(item) {
            let index = this.billingCodes.indexOf(item);
            this.billingCodes.splice(index, 1);
            this.handleBillingCodes();
        },
        async handleBillingCodes() {
            let billingCodes = [];
            for (let i = 0; i < this.billingCodes.length; i++) {
                let billingCode = this.billingCodes[i];
                let defaultAmount = await this.getBillingAmount(billingCode.code);
                billingCodes.push({
                    code: billingCode.code,
                    quantity: billingCode.quantity,
                    minutes: billingCode.minutes,
                    amount: billingCode.amount ? billingCode.amount : defaultAmount,
                });                
            }
            this.$emit('billing-codes', billingCodes);
        },
        async onCodeChange() {
            let billingAmount = await this.getBillingAmount(this.code);
            if (billingAmount){
                this.amount = billingAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace('$', '');        
            }else{
                this.amount = '';
            }

        },
        formatCurrency(amount) {
            if(!amount) return;
            return formatCurrency(amount);
        },
    },    
};
</script>
<style>
</style>